var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGlobe(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_24739_23386)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.49967 17.4168C13.8719 17.4168 17.4163 13.8724 17.4163 9.50016C17.4163 5.12791 13.8719 1.5835 9.49967 1.5835C5.12742 1.5835 1.58301 5.12791 1.58301 9.50016C1.58301 13.8724 5.12742 17.4168 9.49967 17.4168Z",
    stroke: "#07575B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.58301 9.5H17.4163",
    stroke: "#07575B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.49967 1.5835C11.4799 3.75136 12.6052 6.56469 12.6663 9.50016C12.6052 12.4356 11.4799 15.249 9.49967 17.4168C7.51949 15.249 6.39416 12.4356 6.33301 9.50016C6.39416 6.56469 7.51949 3.75136 9.49967 1.5835Z",
    stroke: "#07575B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_24739_23386"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19,
    height: 19,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlobe);
export default __webpack_public_path__ + "static/media/globe.a11ece9423d073e53de653e8361f2346.svg";
export { ForwardRef as ReactComponent };